module.exports = __webpack_public_path__ + "img/12.e0271ca8.jpg";